import React from 'react';
import { Box, HStack } from 'native-base';
import Cash from './Cash';
import Point from './Point';
import { useGeneralStyles } from '~/shared/styles';
import { GIFTCARD_FLOWS } from '@springbig/shared';

const GiftCardBalance = ({
    setIsSetNameModalOpen,
    setOnSubmitAction
}: {
    setIsSetNameModalOpen: (value: boolean) => void
    setOnSubmitAction: (value: GIFTCARD_FLOWS | undefined) => void
}) => {

    const gStyle = useGeneralStyles();

    return (
        <HStack justifyContent={'space-around'} mt={4}>
            <Cash />
            <Box
                borderLeftColor={gStyle.button_background}
                borderLeftWidth={0.60}
                h='70%'
                alignSelf={'center'}
            />
            <Point setOnSubmitAction={setOnSubmitAction} setIsSetNameModalOpen={setIsSetNameModalOpen} />
        </HStack>
    );
};

export default GiftCardBalance;
